import { useApiClient } from "../apiClients";
import { CURRICULUM_ENDPOINTS } from "./endpoints";
import type { CurriculumResponse } from "../../models/domain";

export const useCurriculumApi = () => {
    const apiClient = useApiClient("embed");

    const getCurriculumOverview = () =>
        apiClient.get<CurriculumResponse>(CURRICULUM_ENDPOINTS.OVERVIEW);

    return {
        getCurriculumOverview,
    };
};
